import { api, helpers } from "../../../../utils";
const cafe = {
    default: {
        sp: {
            authen: {
                loadConfig: "authen/loadConfig",
            },
        },
        cftf: {
            logos: [
                {
                    resize: 40,
                    margin: 50,
                    opacity: 65,
                    title: "logo 1",
                    src: "./public/images/upload/profile/MEM000000012/logo-etecco.png",
                    latitudeDegrees: 10.7118299,
                    longitudeDegrees: 106.6557944,
                    Rating: 4,
                    Copyright: "xuyenadaithanh.com",
                    XPComment: "palang điện - máy tời điện - bảo hộ lao động",
                    XPAuthor: "Xuyên Á Đại Thành",
                    XPKeywords: [
                        "palang điện",
                        "máy tời điện",
                        "bảo hộ lao động",
                    ],
                    XPSubject: "palang điện;máy tời điện;bảo hộ lao động",
                },
            ],
            resize: false,
        },
    },
    sms: {
        invalid_inputs: api.sms.invalid_inputs,
    },
};
const df = cafe.default;
const { stored } = api.net.config;
const hlog = helpers.html.log;
const hcpo = helpers.text.cpo;

const write = async (_, payload) => {
    const p = new Promise(async (resolve) => {
        if (!payload || !payload.XPSubject || !Array.isArray(payload.files)) return resolve({ error: cafe.sms.invalid_inputs });
        const {
            key,
            logo,
            latitudeDegrees,
            longitudeDegrees,
            Rating,
            resize,
            Copyright,
            XPComment,
            XPKeywords,
            XPAuthor,
            XPSubject,
        } = payload;
        let formData = new FormData();
        for (let file of payload.files) formData.append(key, file, file.name);
        formData.append("logo", JSON.stringify(logo));
        formData.append("resize", resize);
        formData.append("latitudeDegrees", latitudeDegrees);
        formData.append("longitudeDegrees", longitudeDegrees);
        formData.append("Rating", Rating);
        formData.append("Copyright", Copyright);
        formData.append("XPComment", XPComment);
        formData.append("XPKeywords", XPKeywords);
        formData.append("XPAuthor", XPAuthor);
        formData.append("XPSubject", XPSubject);
        hlog.start("tool.file.metadata.write", "start", payload);
        const res_write = await api.node.origin.file.metadata.write(formData);
        hlog.end("tool.file.metadata.write", "end", res_write);
        resolve(res_write);
    });

    return p;
};

const updateLogo = async ({ rootState, dispatch }, payload) => {
    const p = new Promise(async (resolve) => {
        let { headers } = rootState.useragent;
        if (!headers || !headers.SessionID) return resolve({ error: cafe.sms.session_timeout });
        if (!payload || !payload.src || payload.index <= 0) return resolve({ error: cafe.sms.invalid_inputs });
        const { SessionID } = headers;
        let cftf = rootState.authen.config.ConfigToolFile || df.cftf;
        let ConfigToolFile = hcpo(cftf);
        let {
            index, resize, margin, opacity, title,
            src, latitudeDegrees, longitudeDegrees,
            Rating, Copyright, XPComment, XPAuthor, XPKeywords,
        } = payload;
        resize = ~~resize;
        margin = ~~margin;
        opacity = ~~opacity;
        let logo = {
            resize, margin, opacity, title,
            src, latitudeDegrees, longitudeDegrees,
            Rating, Copyright, XPComment, XPAuthor, XPKeywords,
        };
        ConfigToolFile.logos[index - 1] = logo;
        hlog.start("tool.file.metadata.logo.update", "start", ConfigToolFile);
        ConfigToolFile = JSON.stringify(ConfigToolFile);
        const storeName = stored.auth.UpdateMemberConfig;
        let filter = { SessionID, ConfigToolFile };
        let res_udpate = await api.net.data.bot.load.list({ storeName, filter });
        await dispatch(df.sp.authen.loadConfig, null, { root: true });
        hlog.end("tool.file.metadata.logo.update", "end", res_udpate);
        resolve(res_udpate);
    });

    return p;
};

const addLogo = async ({ rootState, dispatch }, payload) => {
    const p = new Promise(async (resolve) => {
        let { headers } = rootState.useragent;
        if (!headers || !headers.SessionID) return resolve({ error: cafe.sms.session_timeout });
        if (!payload || !payload.src) return resolve({ error: cafe.sms.invalid_inputs });
        const { SessionID } = headers;
        let cftf = rootState.authen.config.ConfigToolFile || df.cftf;
        let ConfigToolFile = hcpo(cftf);
        ConfigToolFile.logos = ConfigToolFile.logos || [];
        let {
            resize, margin, opacity, title, src,
            latitudeDegrees, longitudeDegrees, Rating,
            Copyright, XPComment, XPAuthor, XPKeywords
        } = payload;
        resize = ~~resize;
        margin = ~~margin;
        opacity = ~~opacity;
        let logo = {
            resize, margin, opacity, title, src,
            latitudeDegrees, longitudeDegrees, Rating,
            Copyright, XPComment, XPAuthor, XPKeywords,
        };
        ConfigToolFile.logos.push(logo);
        hlog.start("tool.file.metadata.logo.add", "start", ConfigToolFile);
        ConfigToolFile = JSON.stringify(ConfigToolFile);
        const storeName = stored.auth.UpdateMemberConfig;
        let filter = { SessionID, ConfigToolFile };
        let res_add = await api.net.data.bot.load.list({ storeName, filter });
        await dispatch(df.sp.authen.loadConfig, null, { root: true });
        hlog.end("tool.file.metadata.logo.add", "end", res_add);
        resolve(res_add);
    });

    return p;
};

export default {
    write,
    addLogo,
    updateLogo,
};



// WEBPACK FOOTER //
// src/store/tool/file/metadata/actions.js